import axios from "axios";


export const updatePanelistCategory = async (data) => {
  try {
    const res = await axios.post(
      `/api/company/updatePanelistCategory`, data
    );
    return res;
  } catch (error) {
  }
};

export const getPanelistCategory = async (data) => {
  try {
    const res = await axios.get(
      `/api/company/getPanelistCategory`
    );
    return res;
  } catch (error) {
  }
};
